function extractEmbedIDFromURL(url) {
  let videoID = url.split("/").pop();
  return videoID;
}

/** https://stackoverflow.com/a/50580625 */
document.addEventListener("DOMContentLoaded", function() {
  let youtube = document.querySelectorAll(".youtube");
  
  youtube.forEach(elem => {
    /* 
    - mqdefault 320 x 180
    - hqdefault 480 x 360
    - sddefault - 640 x 480
    - maxresdefault - 1920 x 1080
    */
    var source = "https://img.youtube.com/vi/" + extractEmbedIDFromURL(elem.dataset.embed) + "/sddefault.jpg";

    var image = new Image();
    image.src = source;
    image.alt = elem.dataset.title;
    image.classList.add("embed-responsive-item", "object-fit-cover");
    image.addEventListener("load", function() {
      elem.appendChild(image);
    });
  
    elem.addEventListener("click", function() {
  
      var iframe = document.createElement("iframe");
  
      iframe.classList.add("embed-responsive-item");
      iframe.setAttribute("title", this.dataset.title);
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("defer", "");
      iframe.setAttribute("src", this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
  
      this.innerHTML = "";
      this.appendChild(iframe);
    });
  });
});